import { render, staticRenderFns } from "./SportView.vue?vue&type=template&id=2fd2109e"
import script from "./SportView.vue?vue&type=script&lang=js"
export * from "./SportView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports